import { MerchantId, SetHeaderService } from "@/helper/authenticationHelper";
import { DocumentTemplateHeaderTypeModel, DocumentWithPassCodeModel } from "@/model/document/documentModel";
import service from "../../baseHttpService";
import {
  PrepareDocumentInputData,
  PrepareDocumentPublicLinkInputData,
  PrepareUpdateDetailDocumentInputData,
} from "../documentFacade";

class CombinePaymentNoteService {
  DoGetCombinePaymentNoteDocumentPublicLink(input: DocumentWithPassCodeModel) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareDocumentPublicLinkInputData(input),
    };
    return service.peakOnlineView
      .post("/api/BillingNote/GetCombinePaymentNoteDocumentPublicLink", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetCombinePaymentNoteDocument(input: DocumentTemplateHeaderTypeModel) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareDocumentInputData(input),
    };
    return service.peakOnlineView
      .post("/api/BillingNote/GetCombinePaymentNoteDocument", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoUpdateCombinePaymentNoteDetailDocument(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareUpdateDetailDocumentInputData(input),
    };
    return service.peakOnlineView
      .post("/api/BillingNote/UpdateCombinePaymentNoteDocument", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
}
export default new CombinePaymentNoteService();
